import Vue from 'vue'

import { buildOrdersQueryString } from '@/helpers/ordersQueryParams'
import { newAbortSignal } from '@/store/utils/utils'
import { $themeConfig } from '@themeConfig'

const ORDERS_URL = `${$themeConfig.app.backUrl}/orders`

export function fetchOrders(offset, limit, paramsSearch, signal) {
    return Vue.axios.get(
        `${ORDERS_URL}?limit=${limit}&offset=${offset}${buildOrdersQueryString({
            ...paramsSearch,
        })}`,
        signal ? { signal } : undefined
    )
}

export function fetchOrderById(id) {
    return Vue.axios.get(`${ORDERS_URL}/${id}`)
}

export function updateOrder(id, body) {
    return Vue.axios.put(`${ORDERS_URL}/${id}`, body)
}

// Для заказов в статусе "Ждет начала приготовления"
export function updateOrdersWithImmediateSend(body) {
    return Vue.axios.patch(`${ORDERS_URL}/batch/immediate_send`, body)
}

// Для исполненных заказов
export function completedOrderChangePayments(orderId, body) {
    return Vue.axios.put(`${ORDERS_URL}/${orderId}/completed_payments`, {
        payments: body,
    })
}

export function printOrders(printItems) {
    return Vue.axios.post(`${ORDERS_URL}/print`, { items: printItems })
}

export function printInvoices(orderIds, correlationId) {
    return Vue.axios.post(`${ORDERS_URL}/print-invoices`, {
        order_ids: orderIds,
        correlation_id: correlationId,
    })
}

export function fetchPrintGroup(queueId) {
    if (!queueId) {
        throw new Error('fetchPrintGroup: queueId обязательный параметр')
    }

    return Vue.axios.get(
        `${$themeConfig.app.backUrl}/print/groups/${encodeURIComponent(
            queueId
        )}`
    )
}

export function cancelFiscalCheck(orderId) {
    return Vue.axios.post(`${ORDERS_URL}/${orderId}/undo_receipt`)
}

export function printCheckEvent(orderId, checkTypeId) {
    return Vue.axios.post(
        `${ORDERS_URL}/${orderId}/print_check_events`,
        {
            check_type_id: checkTypeId,
        },
        {
            timeout: 2000,
            signal: newAbortSignal(2000),
        }
    )
}

export function addOrderToFavorites(id) {
    return Vue.axios.post(`${ORDERS_URL}/${id}/favorite`, null)
}

export function removeOrderFromFavorites(id) {
    return Vue.axios.delete(`${ORDERS_URL}/${id}/favorite`)
}
